import { createTheme, type Theme } from '@mui/material/styles';
import { buildMuiTheme } from './buildMuiTheme';
import type { Density } from './densityContext';
import { getPreset } from './registry';
import { DEFAULT_PRESET_ID } from './tokens';

export type ColorMode = 'light' | 'dark';

/**
 * Builds the MUI theme for a colour mode, preset and density. Presets and
 * their tokens live in `presets.ts` / `deriveTokens.ts`; an unknown id falls
 * back to the default "Camptain Indigo" preset.
 */
export function getTheme(
  mode: ColorMode,
  presetId: string = DEFAULT_PRESET_ID,
  density: Density = 'comfortable',
): Theme {
  return createTheme(buildMuiTheme(getPreset(presetId)[mode], mode, density));
}

export { DEFAULT_PRESET_ID } from './tokens';
export type { ThemeCategory, ThemePreset, ThemePresetMeta, ThemeTokens } from './tokens';
export {
  allPresets,
  contrastReport,
  getPreset,
  isKnownPreset,
  presetsByCategory,
  type ContrastReport,
  type PresetGroup,
} from './registry';
export { tokensToCssVars } from './cssVars';
export {
  DENSITIES,
  DENSITY_TOKENS,
  type Density,
  type DensityPreference,
  type DensityTokens,
} from './densityContext';
